import React, { useState } from 'react';
import Select from 'react-select';
import { Table } from "antd";

const BranchTab = () => {

    const columns = [
        { title: "Cargo Type", dataIndex: "cargoType", key: "cargoType" },
        { title: "Stuffing", dataIndex: "stuffing", key: "stuffing" },
        { title: "Basis", dataIndex: "basis", key: "basis" },
        { title: "Container Type", dataIndex: "containerType", key: "containerType" },
        { title: "Commodity", dataIndex: "commodity", key: "commodity" },
        { title: "Amount (INR)", dataIndex: "amount", key: "amount" },
    ];
    
    const dataSource = [
        {
            key: "", // Add a unique key for each row
            SNo: "", // Changed to camelCase
           
        },
    ]

    return (
        <>
            <div className="row">
                <div className="col-md-5">
                                        <div className="card mb-2">
                                            <div className="card-header py-2">
                                                <h4 className='mb-0 text-small'>
                                                Available Branch
                                                </h4>
                                            </div>
                                            <div className="card-body pb-0">
                                                
                                            </div>
                                        </div>

                </div>
                <div className="col-md-2 text-center">
                      --
                      --
                </div>
                <div className="col-md-5">
                <div className="card mb-2">
                                            <div className="card-header py-2">
                                                <h4 className='mb-0 text-small'>
                                                Branch where the stock can be used
                                                </h4>
                                            </div>
                                            <div className="card-body pb-0">
                                                
                                            </div>
                                        </div>
                </div>
            </div>

        </>
    );
};

export default BranchTab
